
import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";

const orderModule = getModule(OrderModule);

@Component
export default class OrderDeliveryProfileWidget extends Vue {

  @Prop({ default: false })
  loading: boolean;

  get deliveryProfile(): any {
    return orderModule.currentDeliveryProfile;
  }

}
